<template lang="pug">
  .payment-settings
    v-container(style="max-width:600px")
      payment-settings-yezza-pay-migrate-banner(:company="company")
      v-expansion-panels.mt-4.px-0.mx-0(v-model="expansionPanels" tile flat outlined)
        template(v-if="allowedPaymentMethods.paymentGateway")
          v-expansion-panel
            v-expansion-panel-header.pa-0(disable-icon-rotate)
              template(v-slot:default='{ open }')
                v-list-item
                  v-list-item-content
                    v-layout
                      div.s1.basic800--text {{ $t('section_online_payment.title') }}
                      v-spacer
                      v-icon.ml-1.mt-n1(color="black" size=24) mdi-chevron-down
                    div.c1.basic600--text(v-if="$currency.code === 'MYR'") {{ $t('section_online_payment.text_1') }}
                    div.c1.basic600--text(v-else) {{ $t('section_online_payment.text_2') }}
              template(v-slot:actions)
                div
            v-expansion-panel-content
              online-payment-list.mt-4(:company="company" :yezzapay="$currency.code === 'MYR'" )
          v-divider

        template(v-if="allowedPaymentMethods.manual && Auth('root', 'payment_bank_transfer')")
          v-expansion-panel
            v-expansion-panel-header.pa-0(disable-icon-rotate)
              template(v-slot:default='{ open }')
                v-list-item
                  v-list-item-content
                    v-layout
                      div.s1.basic800--text {{ $t('section_bank_transfer.title') }}
                      v-spacer
                      v-icon.ml-1.mt-n1(color="black" size=24) mdi-chevron-down
                    div.c1.basic600--text {{ $t('section_bank_transfer.text') }}
              template(v-slot:actions)
                div
            v-expansion-panel-content
              cash-payment-list.mt-4(:company="company")
          v-divider

        template(v-if="allowedPaymentMethods.installment")
          v-expansion-panel
            v-expansion-panel-header.pa-0(disable-icon-rotate)
              template(v-slot:default='{ open }')
                v-list-item
                  v-list-item-content
                    v-layout
                      div.s1.basic800--text {{ $t('section_partial_payment.title') }}
                      v-spacer
                      v-icon.ml-1.mt-n1(color="black" size=24) mdi-chevron-down
                    div.c1.basic600--text {{ $t('section_partial_payment.text') }}
              template(v-slot:actions)
                div
            v-expansion-panel-content
              installment-settings.mt-4(:company="company" @activated="handleActivateInstallment($event)")

      v-layout.mt-8
        v-chip.mx-auto(outlined)
          template(v-slot:default)
            v-layout.ma-2
              div.p2 {{ $t('learn_more_about') }}
              a.ml-1.p2.textColorAccent--text.text-decoration-none(href="https://help.yezza.io/hc/en-my/categories/900000227246-Accept-Payments" target="_blank") {{ $t('payments') }}
              
</template>

<script>
import { mapActions } from 'vuex'

import OnlinePaymentList from '@/components/settings/OnlinePaymentList.vue'
import CashPaymentList from '@/components/settings/CashPaymentList.vue'
import InstallmentSettings from '@/components/settings/InstallmentSettings.vue'
import PaymentSettingsYezzaPayMigrateBanner from '@/components/settings/PaymentSettingsYezzaPayMigrateBanner.vue'

export default {
  name: 'PaymentSettings',
  components: { OnlinePaymentList, CashPaymentList, InstallmentSettings, PaymentSettingsYezzaPayMigrateBanner },
  props: ['company'],
  data () {
    return {
      expansionPanels: undefined,
      addressIsEnabled: false,
      codIsEnabled: false,
      installmentEnabled: false,
      shippingMethod: null,
      allowedPaymentMethods: {
        paymentGateway: true,
        manual: true,
        cod: true,
        installment: true
      },
    }
  },
  mounted () {
    this.fetchInvoiceSettings()
    this.handleReturnFromStripeOnboarding()
    this.handleClickFromYezzaPayNoticeBanner()
  },
  methods: {
    ...mapActions(['showMessage']),
    handleActivateInstallment (val) {
      this.installmentEnabled = val
      this.updateInvoiceSettings()
    },
    fetchInvoiceSettings() {
      this.$axios.get(`/invoice_settings/?company=${this.company.id}`)
        .then((response) => {
          if (response.data.results.length != 0) {
            this.invoiceSettings = response.data.results[0]
            this.addressIsEnabled = this.invoiceSettings.address_enabled
            if (this.invoiceSettings.extra_settings) {
              this.codIsEnabled = this.invoiceSettings.extra_settings.cod_enabled
              this.installmentEnabled = this.invoiceSettings.extra_settings.installment_enabled || false

              this.shippingMethod = this.invoiceSettings.extra_settings.shipping_method

            }
          }
        }).catch(() => {})
    },
    updateInvoiceSettings () {
      const params = {
        company: this.company.id,
        address_enabled: this.addressIsEnabled,
        extra_settings: {
          cod_enabled: this.codIsEnabled,
          shipping_method: this.shippingMethod,
          installment_enabled: this.installmentEnabled,
        }
      }
      if (this.invoiceSettings) {
        this.axios.put(`/invoice_settings/${this.invoiceSettings.id}/`, params)
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
        return
      }
      this.axios.post(`/invoice_settings/`, params)
        .then((resp) => {
            this.invoiceSettings = resp.data
          })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    handleReturnFromStripeOnboarding () {
      if (this.$route.query.from_stripe_onboard) {
        this.expansionPanels = 0
        this.fetchingYezzapaySetting = true
        let textSuccess = 'Yezza Pay was successfully activated'
        let textFail = 'Yezza Pay activation was unsuccessful. Please try again.'
        if (this.$route.query.existing_stripe_migration) {
          textSuccess = 'Yezza Pay (Stripe) was successfully activated'
          textFail = 'Yezza Pay (Stripe) activation was unsuccessful. Please try again.'
        }
        setTimeout(() => {
          this.$axios.get(`/yezzapays/?company=${this.company.id}`).then((response) => {
            if (response.data.results.length > 0 && response.data.results[0].active_fpx_provider === 'stripe') {
              this.showMessage(['success', textSuccess])
            } else {
              this.showMessage(['error', textFail])
            }
          })
          .catch(() => {
            this.showMessage(['error', textFail])
          })
        }, 3000)
      }
    },
    handleClickFromYezzaPayNoticeBanner () {
      this.$watch('$store.state.ui.yezzapayMigrateModal', (val) => {
        if (val) {
          this.expansionPanels = 0
        }
      })
      this.$watch('$store.state.ui.securepayMigrateModal', (val) => {
        if (val) {
          this.expansionPanels = 0
        }
      })
    }
  }
}
</script>

<i18n>
{
  "en": {
    "section_online_payment": {
      "title": "Online Payment",
      "text_1": "Activate Credit / Debit Card and FPX (Online Banking)",
      "text_2": "Activate Credit / Debit Card"
    },
    "section_bank_transfer": {
      "title": "Bank Transfer",
      "text": "Add bank for manual payment"
    },
    "section_partial_payment": {
      "title": "Partial payment",
      "text": "Allow your customers to pay partially"
    }
  },
  "id": {
    "section_online_payment": {
      "title": "Pembayaran online",
      "text_1": "Aktivasi Kartu Kredit/Debit dan FPX (Online Banking) ",
      "text_2": "Aktivasi Kartu Kredit/Debit"
    },
    "section_bank_transfer": {
      "title": "Transfer Bank",
      "text": "Tambahkan bank untuk pembayaran manual"
    },
    "section_partial_payment": {
      "title": "Pembayaran Cicil",
      "text": "Izinkan pelanggan kamu membayar sebagian"
    }
  }
}
</i18n>
